  import {BtmPaymentMethodModel} from './btm-payment.model';

  export class PaymentDetailsModel {
      btmPaymentMethod: BtmPaymentMethodModel;
  }
